import Price from './Price.vue'

export default Price
